import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {ForceRepaintDirective} from "@numizmat/directives";
import {UserReportApiService} from "@numizmat/services/core";
import {UserReportRequest} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-user-report-modal',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ForceRepaintDirective
  ],
  templateUrl: './user-report-modal.component.html',
  styleUrl: './user-report-modal.component.scss'
})
export class UserReportModalComponent {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private userReportApiService: UserReportApiService = inject(UserReportApiService);

  protected userId!: string;
  protected username!: string;
  protected loading: boolean = false;
  protected form: FormGroup = this.initializeForm();

  protected onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    const formValue = this.form.getRawValue();
    const request: UserReportRequest = {
      userId: this.userId,
      description: formValue.description
    };
    this.userReportApiService.insertUserReport(request).subscribe({
      next: response => {
        this.toastrService.success(`Успешно докладвахте ${this.username}!`);
        this.closeModal();
      }
    });
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private initializeForm() {
    return new FormGroup({
      description: new FormControl(null, [Validators.required, Validators.maxLength(2000)])
    });
  }

  get description() {
    return this.form.get('description');
  }
}
